import React from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "What is NFT development services?",
    answer: `<p>NFT development services are used to deploy programs that implement blockchain smart contracts for selling non-interchangeable NFTs in the form of tokens, which in turn are supported by digital or physical assets.</p>`,
  },
  {
    question: "What does a developer for an NFT do?",
    answer: `<p>An NFT developer is expected to create and amend the smart contract that dictates the ownership, transfer, and trading of such assets. They may use any of the blockchains such as Ethereum, Binance Smart Chain, and Solana to execute their smart contracts.</p>`,
  },
  {
    question: "How much does NFT development cost?",
    answer: `<h4>$40,000 to $300,000</h4><p>As most people speak faster than they write, speech recognition is a convenient solution that enables a person to input words into a document without being slowed down in the process. This speed is what makes many people run for it when in need of its services. On the other hand, typing is also handicapping to the communication process since it is time-consuming.</p>`,
  },
  {
    question: "How to Choose an NFT Development Company?",
    answer: `<p>Is the idea of moving to the world of NFTs (Non-Fungible Tokens) amazing to you but the question of how to begin bothering you? For the answer, you should turn to an NFT development company. Here are some convincing reasons why selecting these services is the correct move for your NFT venture:</p>
    <ul>
    <li>Expertise: <p> NFT development companies embody significant information and expertise in the use of blockchain technologies and NFTs. They understand how the smart contracts behind NFTs work and token standards such as ERC 721 and 1155 as well as complicated DApps.</p></li>
    <li>Customized Solutions: <p>In some way or another, each NFT project is unique, thus, ready-made solutions sometimes can hardly meet all your needs. It offers services tailored to the client’s requests and personal interests.</p></li>
    <li>Security and Compliance: <p>NFT development services divide the security measures to protect your platform from risks and cyber threats. They also ensure adherence to proper regulations and standards that can safeguard your users’ property and information.</p></li>
    <li>Security and Compliance: <p>Designing an NFT marketplace involves the integration of various elements such as smart contracts, user authorization, payment processing mechanisms, and front-end design. The NFT marketplace development services help control integration in a way that guarantees the different components interact smoothly and without issues for users.</p></li>
    <li>Ongoing Support and Maintenance: <p>The creation of an NFT marketplace is just the first step. For this reason, you need a constant supply of support and sustainment to become a permanent solution. The NFT development company offers full-service solutions that include bug fixes, periodic updates, and optimizations to ensure that your platform functions optimally.</p></li>
    </ul>`,
  },
];

function FaqLocation(props) {
  return (
    <div
      className="faq_loc p-100 tekrevol_dark_bg home"
      style={{ background: "#F8F8FB" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>NFT Development Service FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
